import { Component, OnInit ,Input } from '@angular/core';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { SwQuickMenusBoxComponent } from './sw-quick-menus-box/sw-quick-menus-box.component';
import { Router } from '@angular/router';

@Component({
  selector: 'sw-quick-menus',
  templateUrl: './sw-quick-menus.component.html',
  styleUrls: ['./sw-quick-menus.component.css']
})
export class SwQuickMenusComponent implements OnInit {
  @Input() opentype = 0; //0默认在当前程序打开，1在新标签页打开
  @Input() width = '23%'
  @Input() hasHeader:boolean = true  //是否有头部，默认有
  @Input() hasBorder:boolean = true  // div.box元素是否有边框
  MenusList:any=[];  //显示的快捷菜单
  initMenusList:any=[];  //请求返回的快捷菜单
  constructor(
    private create:SwCreateModalComponentService,
    private box:SwMassageBoxService,
    private router:Router,
    private http:SwHttpClientService
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.quickMenus()
  }
  clickMenus(){
    //处理要回显的菜单
    this.create.createModal(SwQuickMenusBoxComponent,{selectedMenus:this.initMenusList},this.quickMenus.bind(this))
  }

  quickMenus(){
    this.http.Post(environment.seekerWebAPI + "shortcut/queryShortcut",{}).subscribe(data => {
      if (data["code"] == 200) {
        let uriList = data["data"].filter(item=>item.uri)  //过滤掉没有uri的
        // let uriList = data["data"]
        this.MenusList = uriList 
        this.initMenusList = JSON.parse(JSON.stringify(uriList))
        this.MenusList.push({functionName:'更多',icon:'icon iconfont iconbtn_card',uri:'more'})
        
      } else {
        this.box.danger("获取快捷菜单数据")
      }
    })
  }

  
  RouterLinek(item){
    if(item.uri == 'more'){
      //如果是点击更多,就打开模态框
      this.clickMenus()
    } else {
      if(this.opentype==1){
        let url="#"+item.uri+"?Title="+item.functionName;
        window.open(url);
      }else{
        this.router.navigate([item.uri], {
          queryParams: {Title:item.functionName} ,
        });
      } 
    }
  }
}
